/* eslint-disable no-param-reassign */

import { v4 as uuid } from 'uuid';

import { sessionStorageStrategy } from '../data/strategies';

export function makeSkeepersTracking ({ api }) {
    return {
        namespaced: true,
        state: {
            tracked: new Set(),
            session: null,
        },
        getters: {
            sessionKey (state, getters, rootState) {
                return `${rootState.solution.id}:session`;
            },
        },
        mutations: {
            ADD_TRACKED (state, event) {
                state.tracked.add(event);
            },
            SET_SESSION (state, session) {
                state.session = session;
            },
        },
        actions: {
            trackEvent ({ state, rootState, commit }, event) {
                const { utm } = rootState.tracking;

                if (state.tracked.has(event)) {
                    console.log(`[Tracking:Skeepers] ${event} (skipped because already tracked)`);
                } else {
                    console.log(`[Tracking:Skeepers] ${event}`);
                    api.trackEvent({
                        solutionId: rootState.solution.id,
                        event,
                        utmSource: utm.source,
                        isAnonymous: true,
                        session: state.session,
                    });
                    commit('ADD_TRACKED', event);
                }
            },
            /**
             * Creates a short-lived anonymous session ID to be used for subsequent tracking requests
             */
            init ({ getters, commit }) {
                const session = sessionStorageStrategy(getters.sessionKey) || uuid();

                sessionStorage.setItem(getters.sessionKey, session);
                commit('SET_SESSION', session);

                console.log(`[Tracking:Skeepers] ✅ Initialized (session: ${session})`);
            },
        },
    };
}
